// extracted by mini-css-extract-plugin
export default {"accordionGroup":"ofDlirhF700GTKUtE2nn","footerText":"hBGJiAptigMyGlnBcFQn"};